/* eslint-disable prefer-template */
/* eslint-disable no-param-reassign */
/* eslint-disable semi */
/* eslint-disable camelcase */
import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import api from '../../service/api';
import { ROLEQUERYINIT, QUERYPERMISSION, RANGEINIT, MANAGE_AUTH, HASHOBJ } from './roleReducer';

export const ROLEQUERYINIT_ASYNC = ROLEQUERYINIT + '_ASYNC_ROLE';
export const QUERYPERMISSION_ASYNC = QUERYPERMISSION + '_ASYNC_ROLE';
export const QUERYPERMISSION_ASYNC_ONLY_LOOK = QUERYPERMISSION + '_ASYNC_ONLY_LOOK';
export const RANGEINIT_ASYNC = RANGEINIT + '_ASYNC_ROLE';

export const SUBMITMODALMANAGE_ASYNC = 'SUBMITMODALMANAGE_ASYNC_ASYNC_ROLE';
export const VALIDATEINFO_ASYNC = 'VALIDATEINFO_ASYNC_ROLE';
export const DATASUBMIT_ASYNC = 'DATASUBMIT_ASYNC_ROLE';
export const ADDINIT_ASYNC = 'ADDINIT_ASYNC_ROLE';
export const QUERYPERMISSION_ASYNC_ONLY_PEIZHI = 'QUERYPERMISSION_ASYNC_ONLY_PEIZHI';

// worker
export function* roleQueryInitAsync() {
  const res = yield api.roleQueryInit();

  yield put({
    type: ROLEQUERYINIT,
    roles: res.data,
  });
}

export function* addInit() {
  const res = yield api.addInit();
  console.log(res);
  yield put({
    type: QUERYPERMISSION,
    queryPermission: res.resourceInfo.resourceList,
  });

  yield put({
    type: MANAGE_AUTH,
    isShow: true,
  });
}

export function* queryPermissionAsync(action) {
  const res = yield api.queryPermission({ roleId: action.roleId });
  console.log(res);

  const res1 = yield api.addInit();
  console.log(res1);

  yield put({
    type: QUERYPERMISSION,
    queryPermission: res1.resourceInfo.resourceList,
  });

  yield put({
    type: HASHOBJ,
    hashObj: res.data,
  })

  yield put({
    type: MANAGE_AUTH,
    isShow: true,
  });
}

export function* queryPermissionAsync_onlypeizhi(action) {
  const res = yield api.queryPermission({ roleId: action.roleId });

  const res1 = yield api.addInit();
  console.log(res1);

  yield put({
    type: QUERYPERMISSION,
    queryPermission: {
      data: res1.resourceInfo,
      hashObj: res.data,
    },
  });

  yield put({
    type: MANAGE_AUTH,
    isShow: true,
  });
}

export function* queryPermissionAsync_onlyLook(action) {
  const res = yield api.queryPermission({ roleId: action.roleId });
  console.log(res);
  yield put({
    type: QUERYPERMISSION,
    queryPermission: res.data,
  });
}

export function* submitModalManage(action) {
  const res = yield api.updateSubmit(action.option);
  console.log(res);
}

export function* validateInfo(action) {
  const res = yield api.validateInfo(action.option);
  console.log(res);
}

export function* dataSubmit(action) {
  const res = yield api.dataSubmit(action.option);
  console.log(res);
}

export function* rangeInitAsync() {
  const res = yield api.rangeInit();
  console.log(res);

  yield put({
    type: RANGEINIT,
    roleAndProduct: {
      userRoleList: res.userRoleList,
      productsList: res.productsList,
      isManageAll: res.isManageAll,
    },
  });
}

// watcher
export default function* watchRootSaga() {
  yield takeLatest(ROLEQUERYINIT_ASYNC, roleQueryInitAsync);
  yield takeLatest(QUERYPERMISSION_ASYNC, queryPermissionAsync);
  yield takeLatest(SUBMITMODALMANAGE_ASYNC, submitModalManage);
  yield takeLatest(VALIDATEINFO_ASYNC, validateInfo);
  yield takeLatest(RANGEINIT_ASYNC, rangeInitAsync);
  yield takeLatest(DATASUBMIT_ASYNC, dataSubmit);
  yield takeLatest(ADDINIT_ASYNC, addInit);
  yield takeLatest(QUERYPERMISSION_ASYNC_ONLY_LOOK, queryPermissionAsync_onlyLook);
  yield takeLatest(QUERYPERMISSION_ASYNC_ONLY_PEIZHI, queryPermissionAsync_onlypeizhi);
}



// WEBPACK FOOTER //
// ./src/views/Role/saga.js